<template>
  <b-row>
    <b-col>
      <b-card :no-body="allowCollapse && !isCollapsed && allowCardNoBody">
        <div slot="header">
          <b-row align-v="center">
            {{ this.$lang.selectSearch }}
            <b-col class="d-flex align-items-center">
              <div>
                <strong v-if="title">
                  <span v-html="title" />
                  <b
                    class="badge badge-pill badge-primary fontSize-15 ml-1"
                    v-if="showTotals && totalRows"
                  >
                    {{ totalRows }}</b
                  >
                  <span v-if="headerTitle && items.length > 0"
                    >({{ headerTitle }} {{ items.length }})</span
                  >
                </strong>
                <template v-else>
                  <slot name="title-bar"></slot>
                </template>
              </div>
            </b-col>
            <b-col>
              <div class="float-right">
                <BaseButtons
                  :url="url"
                  :resourceKey="resourceKey"
                  :filterHeaders="filterheaders"
                  :permissions="permission"
                  :extraButtons="extraButtons"
                  :defaultViewCount="defaultViewCount"
                  :hasSelectPerPage="visibleViewCount"
                  @handleSelectPerPage="changeViewCount"
                  :hasHiddenFields="visibleSettings"
                  @handleHiddenFields="showFilterModal"
                  :hasUploadExcel="isImportExcel"
                  :uploadExcelTooltip="isImportExcelTooltip"
                  @handleUploadExcel="importExcel"
                  :hasExportExcel="exportable"
                  :hasRefresh="refreshButton"
                  @handleRefresh="refreshList"
                  :paramsData="paramsData"
                  :hasFilterCache="
                    !!(
                      showFilterBtn &&
                      filterCatch &&
                      Object.values(paramsData).length
                    )
                  "
                  :hasFilter="!!(showFilterBtn && filterheaders.length)"
                  @handleFilter="openFilter"
                  :hasAdd="visibleAdd && buttons && includes('add', buttons)"
                  @handleAdd="handleAdd"
                  @getParamsPage="getParamsPage"
                  @fetchData="getItems"
                  :otherExportExcelParams="otherExportExcelParams"
                >
                  <template slot="buttons">
                    <slot name="customHeaderButtonsLast" />
                    <slot name="headerButtonsLast" />
                    <slot name="headerButtons" />
                  </template>
                </BaseButtons>
                <b-button
                  v-if="allowCollapse && items.length"
                  @click="isCollapsed = !isCollapsed"
                  :class="
                    items.length > 0 ? 'btn-success ml-2' : 'btn-lightgray ml-2'
                  "
                >
                  <i
                    :class="isCollapsed ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                  ></i>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay :show="isOverlay" rounded="sm" :opacity="0.2">
          <template v-slot:overlay>
            <div position-absolute>
              <i class="fa fa-clock-od fa-6x" style="font-size: 48px"></i>
            </div>
          </template>

          <b-collapse
            id="collapseSearchTable"
            :visible="searchTableCollapsed"
            class="mt-2"
          >
            <b-row class="position-relative min-height-filter">
              <b-col :class="classData">
                <div v-if="items.length">
                  <b-alert :variant="colorAlert" :show="showAlert" dismissible>
                    <div v-html="titleAlert" />
                  </b-alert>
                  <slot name="alerts"></slot>
                  <searchData
                    :disabledDragRow="disabledDragRow"
                    :table-data="availableItems"
                    :fields="availableColumns"
                    :perPage="viewCount"
                    :total_pages="total_pages"
                    :striped="true"
                    bordered
                    :remove="remove"
                    :modify="editItem"
                    :isBusy="loadingItem || isLoading"
                    :changePage="changePage"
                    :currentPage="page"
                    :totalRows="totalRows"
                    :editable="editable"
                    :removable="removable"
                    :toggleable="toggleable"
                    :toggle="toggleItem"
                    :isConfirmedFn="isConfirmedFn"
                    :editTitle="edit_label"
                    :removeTitle="remove_label"
                    :dynamicButtons="dynamicButtons"
                    :permissionButtons="permission"
                    @toggleCollaps="toggleCollaps"
                    @showCompetencyCount="showCompetencyCount"
                    :showPaginationTop="showPaginationTop"
                    :itemTopHeader="itemTopHeader"
                    :hasCompetencyCountLink="hasCompetencyCountLink"
                    @showPlace="showPlace"
                    @row-clicked="rowClicked"
                    :showCheckBox="showCheckBox"
                    :showRowAllSelected="showRowAllSelected"
                    :handleCheckBoxCondition="handleCheckBoxCondition"
                    :otherData="otherData"
                    @rowSelected="rowSelected"
                    @rowAllItems="rowAllItems"
                    @rowAllSelected="rowAllSelected"
                    @countClicked="countClicked"
                  >
                    <template v-slot:cell(buttons)="prop">
                      <slot name="buttons" :itemsData="prop.itemsData"></slot>
                    </template>
                    <template slot="contentCollaps" slot-scope="{ row }">
                      <slot name="contentCollaps" :row="row" />
                    </template>
                  </searchData>
                </div>
                <div class="text-center" v-else>
                  <LoadingSpinner :loading="loadingItem || isLoading" />
                  <br v-if="showAlert & !loadingItem" />
                  <div v-if="!loadingItem" class="w-100 text-center">
                    <h5 class="w-100 text-center">
                      {{
                        isAdmin(this.parentPermissions)
                          ? dataNotExist || $lang.noData
                          : $lang.dataNotExist
                      }}
                    </h5>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-collapse>
        </b-overlay>
        <slot name="details"></slot>
      </b-card>
    </b-col>
    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      header-bg-variant="primary"
      header-class="text-white"
      content-class="border-primary"
      v-model="filterModal"
      ok-only
      @ok="doFilter"
      :ok-title="$lang.submitButton"
    >
      <p>{{ $lang.search.columns_setting_hint }}</p>
      <b-form-group>
        <b-form-checkbox
          class="mb-2"
          v-model="filterAllSelected"
          :indeterminate="indeterminate"
          aria-describedby="flavours"
          aria-controls="flavours"
          @change="toggleAllFilters"
          size="lg"
        >
          <span class="column-span">
            {{
              filterAllSelected
                ? $lang.search.all_deselect
                : $lang.search.all_select
            }}
          </span>
        </b-form-checkbox>

        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="filterSelected"
          name="flavour-1"
          stacked
          class="pull-right w-100"
          cols="6"
          size="lg"
          @change="updateSortedColumn"
        >
          <draggable
            v-model="columns"
            group="people"
            @start="drag = true"
            @end="drag = false"
            @change="updateSortedColumn"
            tags="ul"
            ghost-class="moving-column"
          >
            <div
              v-bind:key="index"
              v-for="(column, index) in columns"
              name="checkbox-1"
              class="p-2 mb-2 d-flex align-items-center justify-content-between dragColumn cursor-move"
            >
              <b-form-checkbox :value="column.label">
                <span class="m-1 column-span">{{ column.label }}</span>
              </b-form-checkbox>
              <i class="fas fa-arrows-alt fa-lg pull-left text-muted" />
            </div>
          </draggable>
        </b-form-checkbox-group>
      </b-form-group>
    </b-modal>
    <b-modal
      :title="$lang.delete"
      header-bg-variant="danger"
      v-model="deleteModal"
      :ok-title="$lang.delete"
      ok-variant="danger"
      :cancel-title="$lang.cancel"
      cancel-variant="success"
      @cancel="!deleteModal"
      @ok="removing"
      :size="removeModalSize"
      @hidden="removeModalHidden"
    >
      <b-overlay :show="loadingItem">
        <p>{{ $lang.search.delete_modal_description }}</p>
        <searchData
          :table-data="[confirmRemoveItem]"
          :fields="availableColumns.slice(0, availableColumns.length - 1)"
          :striped="true"
          bordered
          :readOnly="true"
          :allowPaginate="false"
          :allowRow="false"
          :editTitle="editLabel"
          :removeTitle="removeLabel"
          :searchMode="false"
        ></searchData>
        <slot name="removeModalOtherData" />
      </b-overlay>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      title
      v-model="addModal"
      hide-footer
      hide-header
      header-bg-variant="success"
      content-class="border-success"
      :modal-end-up="handleAddModal"
      :size="addModalSize"
    >
      <slot name="addModal" :close="handleAddModal"></slot>
    </b-modal>
  </b-row>
</template>
<script>
import searchData from "@/components/base/searchData";
import BaseButtons from "@/components/global/BaseButtons";
import draggable from "vuedraggable";
import { mapActions } from "vuex";
import { pathOr, includes } from "ramda";
import filterMethods from "@/mixin/filterMethods.js";
import LoadingSpinner from "./LoadingSpinner";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  extends: filterMethods,
  components: {
    searchData,
    draggable,
    BaseButtons,
    LoadingSpinner,
  },
  props: {
    isOverlay: {
      type: Boolean,
      default: false,
    },
    showTotals: {
      type: Boolean,
      default: true,
    },
    isImportExcel: {
      type: Boolean,
      default: false,
    },
    sampleDownload: {
      type: String,
      default: "",
    },
    isImportExcelTooltip: {
      type: String,
      default: "",
    },
    showFilterBtn: {
      type: Boolean,
      default: true,
    },
    choosedItem: {
      type: [Object, String, Array],
      default: () => {},
    },
    headerTitle: {
      type: String,
      default: "",
    },
    dataNotExist: {
      type: String,
      default: "",
    },
    itemTopHeader: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => {},
    },
    forceCollapse: {
      type: Boolean,
      default: false,
    },
    allowCardNoBody: {
      type: Boolean,
      default: true,
    },
    allowCollapse: {
      type: Boolean,
      default: false,
    },
    showPaginationTop: {
      type: Boolean,
      default: false,
    },
    allowOperate: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowRemove: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: "",
    },
    dynamicButtons: {
      type: [Array, Function],
      default: () => [],
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    colorTable: {
      type: Boolean,
      default: false,
    },
    changeColorTable: {
      type: [Array, Function],
      default: () => [],
    },
    colorRows: {
      type: Boolean,
      default: false,
    },
    changeColorRow: {
      type: [Array, Function],
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    editLabel: {
      type: String,
      default: "",
    },
    removeLabel: {
      type: String,
      default: "",
    },
    remove_item: {
      type: Function,
    },
    toggle_item: {
      type: Function,
    },
    editRoute: {
      type: Boolean,
      default: true,
    },
    add_item: {
      type: Function,
    },
    config: {
      type: String,
      default: "",
    },
    toggleable: {
      type: Boolean,
      default: false,
    },
    addModalSize: {
      type: String,
      default: "md",
    },
    removeModalSize: {
      type: String,
      default: "md",
    },
    primaryKey: {
      type: String,
      default: "id",
    },
    visibleSearch: {
      type: Boolean,
      default: true,
    },
    visibleSettings: {
      type: Boolean,
      default: true,
    },
    visibleExport: {
      type: Boolean,
      default: true,
    },
    visibleViewCount: {
      type: Boolean,
      default: true,
    },
    visibleFilters: {
      type: Boolean,
      default: true,
    },
    visibleAdd: {
      type: Boolean,
      default: true,
    },
    baseButtonAdd: {
      type: Boolean,
      default: false,
    },
    routeName: {
      type: String,
      default: null,
    },
    openNewTab: {
      type: Boolean,
      default: false,
    },
    // فیلدهایی که در نمایش جدول جز آن نمایش داده نشود
    allowFields: {
      type: Object,
      default() {
        return {};
      },
    },
    // فیلد‌هایی که در نمایش جدول نباید نمایش داده شود
    disAllowFields: {
      type: Array,
      default() {
        return ["is_enable"];
      },
    },
    // فیلد‌هایی که بصورت دیفالت پنهان هستند و باید از تنظیمات ستون‌ها آنها را نمایش داد

    hiddenFields: {
      type: Array,
      default() {
        return ["created_at", "created_by", "updated_by", "updated_at"];
      },
    },
    justifyFields: {
      type: Array,
      default() {
        return ["description"];
      },
    },
    permissionButtons: {
      type: Object,
      default() {
        return {};
      },
    },
    defaultViewCount: {
      type: Number,
      default: 10,
    },
    disabledDragRow: {
      type: Boolean,
      default: true,
    },
    order_by: {
      type: String,
      default: "",
    },
    urlImportExcel: {
      type: String,
      default: "",
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    showLoading: {
      type: Boolean,
      default: true,
    },
    colorAlert: {
      type: String,
      default: "",
    },
    showAlert: {
      type: Boolean,
      default: false,
    },
    titleAlert: {
      type: String,
      default: "",
    },
    filterCatch: {
      type: Boolean,
      default: true,
    },
    operationField: {
      type: String,
      default: "",
    },
    editByRowClick: {
      type: Boolean,
      default: false,
    },
    refreshButton: {
      type: Boolean,
      default: true,
    },
    openCollapsed: {
      type: Boolean,
      default: false,
    },
    hasCompetencyCountLink: {
      type: Boolean,
      default: true,
    },
    extraButtons: {
      type: Array,
      default: () => [],
    },
    showCheckBox: {
      type: Boolean,
      default: false,
    },
    showRowAllSelected: {
      type: Boolean,
      default: true,
    },
    handleCheckBoxCondition: {
      type: Function,
      default: () => {},
    },
    getColVariant: {
      type: Function,
      default: () => {},
    },
    otherExportExcelParams: {
      type: Object,
      default: null,
    },
    isConfirmedFn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      showSomeBtn: false,
      permission: [],
      isCollapsed: this.openCollapsed,
      loadingItem: false,
      items: [],
      inputSearch: "",
      drag: true,
      columns: [],
      total_pages: 0,
      indeterminate: false,
      viewCount: this.defaultViewCount,
      page: 1,
      buttons: [],
      deleteModal: false,
      addModal: false,
      totalRows: 0,
      confirmRemoveItem: null,
      editable: false,
      removable: false,
      edit_label: this.$lang.edit,
      remove_label: this.$lang.remove,
      searchBarCollapsed: false,
      filterModal: false,
      filterSelected: [],
      filterAllSelected: false,
      filter: false,
      classData: "col-12",
      filterheaders: [],
      filterItems: {},
      paramsData: {},
      paramsPage: {},
      exportable: false,
      resourceKey: "",
    };
  },
  watch: {
    choosedItem() {},
    filterSelected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.filterAllSelected = false;
      } else if (
        newVal.length === this.columns.map(({ label }) => label).slice().length
      ) {
        this.indeterminate = false;
        this.filterAllSelected = true;
      } else {
        this.indeterminate = true;
        this.filterAllSelected = false;
      }

      if (this.items && this.items.length) this.updateConfig();
    },
    buttons() {
      if (this.buttons) {
        this.editable =
          this.allowEdit &&
          (this.buttons.includes("edit") || this.buttons.includes("view"))
            ? true
            : false;
        this.removable = this.allowRemove && this.buttons.includes("admin");
      }
    },
  },
  computed: {
    availableItems() {
      if (!this.choosedItem || Object.keys(this.choosedItem).length === 0)
        return this.items;
      else if (
        typeof this.choosedItem == String ||
        typeof this.choosedItem == Number
      )
        return this.items.find((x) => x[this.primaryKey] == this.choosedItem);
      else if (Array.isArray(this.choosedItem)) return this.choosedItem;
      else if (typeof this.choosedItem == "object") return [this.choosedItem];
      return [];
    },
    searchTableCollapsed() {
      if (this.allowCollapse && !this.isCollapsed) return false;
      else return true;
    },
    visibleSearchBarCollapse() {
      if (
        !this.visibleSearch &&
        !this.visibleSettings &&
        !this.visibleExport &&
        !this.visibleFilters &&
        !this.visibleViewCount
      )
        return false;
      else return true;
    },
    availableColumns() {
      let cols = this.columns.map((column, index) => {
        if (this.filterSelected.includes(column.label)) {
          column.thClass = "text-center";
          column.tdClass = "text-center";
          column.index = this.filterSelected.indexOf(column.label) + 1;
        } else if (
          this.justifyFields.includes(column.key) &&
          this.filterSelected.includes(column.label)
        ) {
          column.tdClass = "text-justify";
        } else {
          column.thClass = "d-none";
          column.tdClass = "d-none";
          column.index = -1;
        }
        column.variant = this.getColVariant(index);

        return column;
      });
      let columns = [];
      if (!this.disabledDragRow) {
        columns = [...cols.sort((a, b) => a.idx - b.idx)];
      } else {
        columns = [
          {
            label: "",
            key: "row",
            sortable: false,
            index: 0,
            selected: false,
          },
          ...cols.sort((a, b) => a.idx - b.idx),
        ];
      }

      if (this.allowOperate && cols.length) {
        columns.push({
          label: this.operationField || this.$lang.operation,
          key: "button",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center",
        });
      }

      return columns;
    },
  },
  created() {
    if (this.editLabel != "") this.edit_label = this.editLabel;
    if (this.removeLabel != "") this.remove_label = this.removeLabel;
    let config = {};

    if (this.config && this.config in this.$store.state.searchConfig) {
      config = this.$store.state.searchConfig[this.config];
      (this.page = config.page),
        (this.viewCount = config.viewCount),
        (this.filterSelected = config.filterSelected);
    }
    this.fillTable(false)
      .then(() => {
        // To-Do: check config filter Selected

        if (this.filterSelected && this.filterSelected.length) {
          let labels = this.columns
            .filter(
              (label) =>
                !this.hiddenFields || !this.hiddenFields.includes(label.key)
            )
            .map(({ label }) => label);
          this.filterSelected = this.filterSelected.filter((x) =>
            labels.includes(x)
          );

          /* در صورتی که یکی از المان‌های نوار بالایی جستجو فعال و قابل نمایش باشد
                      مقدار collapse برابر true می شود
                      تا این المان‌ها در حالت اولیه قابل نمایش باشد
                      */
          if (this.inputSearch) this.searchBarCollapsed = true;
          else this.searchBarCollapsed = this.forceCollapse;
        } else {
          let labels = this.columns
            .filter(
              (label) =>
                !this.hiddenFields || !this.hiddenFields.includes(label.key)
            )
            .map(({ label }) => label);
          this.filterSelected = labels;
          this.updateConfig();
        }
      })
      .catch();
  },
  methods: {
    ...mapActions(["changeSearchConfig"]),
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    showPlace(row) {
      this.$emit("showPlace", row);
    },
    toggleCollaps(item) {
      this.$emit("toggleCollaps", item);
    },
    changeSomeBtn() {
      this.showSomeBtn = !this.showSomeBtn;
    },
    importExcel() {
      this.$emit("importExcel");
    },
    showCompetencyCount(item) {
      this.$emit("showCompetencyCount", item);
    },
    addModalHide() {
      this.$emit("add-modal-hide");
    },
    toggleItem(item) {
      this.loadingItem = true;
      if (this.toggle_item != undefined) {
        this.toggle_item(item)
          .then(() => {
            this.getItems();
          })
          .catch(() => {
            this.loadingItem = false;
          });
      } else {
        let primaryKey = this.primaryKey ? this.primaryKey : "id";
        return this.$httpService
          .patch(this.url + "/" + item[primaryKey], {
            is_enable: !item.is_enable ? 1 : 0,
          })
          .then((response) => {
            this.$notify.success(response.data.message);
            this.getItems();
          })
          .catch((err) => {
            this.$notify.error(err.response.data.message);
            this.loadingItem = false;
          });
      }
    },
    removing(e) {
      e.preventDefault();
      if (this.remove_item) {
        const removeItemPromise = this.remove_item(this.confirmRemoveItem);
        /* guidance: check other input required */
        if (removeItemPromise === "required_inputs") return;
        this.loadingItem = true;
        removeItemPromise
          .then(() => {
            this.deleteModal = false;
            this.getItems();
          })
          .catch(() => {
            this.loadingItem = false;
          });
      } else {
        let id = this.primaryKey ? this.primaryKey : "id";
        this.loadingItem = true;
        return this.$httpService
          .delete(this.url + "/" + this.confirmRemoveItem[this.primaryKey])
          .then((response) => {
            this.$notify.success(response.data.message);
            this.deleteModal = false;
            this.getItems();
          })
          .catch((err) => {
            this.$notify.error(err.response.data.message);
            this.loadingItem = false;
          });
      }
    },
    handleAddModal() {
      this.addModal = !this.addModal;
      this.hiddenAddModal();
    },
    hiddenAddModal() {
      // this.loadingItem = true;
      if (this.add_item != undefined) {
        this.add_item().finally(() => {
          // this.getItems();
        });
      } else {
        // this.getItems();
      }
    },
    search() {},
    doFilter() {
      this.filterModal = false;
    },
    toggleAllFilters(checked) {
      this.filterSelected = checked
        ? this.columns.map(({ label }) => label).slice()
        : [];
    },
    updateSortedColumn() {
      this.filterSelected = this.columns.map((column) => {
        if (this.filterSelected.includes(column.label)) {
          return column.label;
        }
      });
      this.updateConfig;
    },
    updateConfig() {
      // save search config to vuex
      let config = {};
      config[this.config] = {
        page: this.page,
        inputSearch: this.inputSearch,
        viewCount: this.viewCount,
        filterSelected: this.filterSelected,
      };

      this.changeSearchConfig(config);
    },
    extractValue(item, v) {
      if (item[v] && typeof item[v] === "object") {
        if ("jalali" in item[v]) {
          return item[v].jalali;
        } else if ("caption" in item[v]) {
          return item[v]["caption"];
        } else if ("name" in item[v]) {
          return item[v]["name"];
        } else if ("view_label" in item[v]) {
          return item[v].view_label ? item[v].view_label : "";
        }
      } else {
        return item[v];
      }
    },
    genaratePermistionButton(permitions) {
      if (permitions) {
        if (permitions.includes("admin")) {
          this.buttons = ["add", "delete", "edit", "enable", "view"];
        }
        if (permitions.includes("edit")) {
          this.buttons = ["edit", "enable"];
        }
        if (permitions.includes("view")) {
          this.buttons = ["view"];
        }
      } else {
        this.buttons = [];
      }
    },
    async openFilter() {
      this.filter = !this.filter;
      if (this.filter) {
        this.classData = "col-12 col-md-12";
      } else {
        this.classData = "col-12";
      }
    },
    getItems(updateConfig = true) {
      if (this.showLoading) this.loadingItem = true;
      let url = this.url;
      for (const key in this.params) {
        if (Object.hasOwnProperty.call(this.params, key)) {
          const element = this.params[key];
          this.paramsPage[key] = element;
        }
      }

      let { per_page, page, order_by, locale_id, ...otherFilter } =
        this.paramsPage;
      this.paramsData = otherFilter;
      this.items = [];

      return this.$httpService
        .get(url, this.paramsPage)
        .then((response) => {
          if (this.parentPermissions.length > 0)
            this.permission = this.parentPermissions;
          else this.permission = response.data.permissions;
          this.$emit("getPermisson", this.permission);
          this.genaratePermistionButton(this.permission);
          this.filterheaders = response.data.filters.map((x) => {
            return {
              ...x,
              search_scope: x.search_scope ? x.search_scope : null,
              loader: !x.open,
              selected: this.paramsPage[x.key_service]
                ? this.paramsPage[x.key_service]
                : x.type == "checkbox_multiselect" || x.advanced
                ? []
                : "",
            };
          });

          if (response.data.data && "result" in response.data.data) {
            let items = response.data.data.result;
            this.$emit("getRows", items);
            this.resourceKey = pathOr("", ["data", "resource"], response);
            this.otherData = response.data.other;
            this.$emit("getOther", this.otherData);
            if (!items) {
              this.items = [];

              this.loadingItem = false;
              return true;
            }

            this.totalRows = response.data.data.total;
            this.total_pages = response.data.data.total_pages;
            if (items.length > 0) {
              //use allow field from outside
              if (Object.keys(this.allowFields).length !== 0) {
                if (this.colorTable) {
                  this.columns = this.changeColorTable(this.allowFields);
                } else {
                  this.columns = Object.keys(this.allowFields).map((item) => {
                    return {
                      label: this.allowFields[item],
                      key: item,
                      sortable: true,
                    };
                  });
                }
              } else {
                // extract field from api
                Object.keys(items[0]).map((col) => {
                  if (
                    !this.disAllowFields ||
                    !this.disAllowFields.includes(col)
                  ) {
                    if (col in this.$lang) {
                      this.columns.push({
                        label: this.$lang[col],
                        key: col,
                        sortable: true,
                      });
                    }
                  }
                });
              }
              items = items.map((item) => {
                Object.keys(item).map((v) => {
                  // برای نگهداری دیتای قبلی
                  if (typeof item[v] === "object") {
                    item[v.concat("_object")] = item[v];
                  }
                  if (item[v] && Array.isArray(item[v])) {
                    item[v] = item[v]
                      .map((value, key) => {
                        return this.extractValue(item[v], key);
                      })
                      .join("، ");
                  } else {
                    if (
                      !(
                        this.allowFields &&
                        Object.keys(this.allowFields).length > 0
                      )
                    ) {
                      item[v] = this.extractValue(item, v);
                    }
                  }
                });
                return item;
              });
              if (this.colorRows == true) {
                this.items = this.changeColorRow(items);
              } else {
                this.items = items;
              }
            } else {
              this.items = [];
            }

            if (!this.visibleFilters) {
              let labels = this.columns
                .filter(
                  (label) =>
                    !this.hiddenFields || !this.hiddenFields.includes(label.key)
                )
                .map(({ label }) => label);
              this.filterSelected = labels;
            }
            this.exportable = pathOr(false, ["exportable"], response.data);

            this.loadingItem = false;
            return true;
          } else {
            this.items = [];

            this.loadingItem = false;
            return true;
          }
        })
        .catch((error) => {
          this.$generateError(error);
        })
        .finally(() => {
          /* در صورتی که جستجو چیزی برنگردانده باشد
                         مقدار فیلتر ستون‌ها خالی است و پس از جستجو کردن و مقدار داشتن، باید دوباره از اول فیلتر ستون‌ها پر شود
                        */
          if (
            this.filterSelected.length == 0 &&
            this.columns &&
            this.columns.length
          )
            this.filterSelected = this.columns.map((col) => col.label);

          // در صورتی که نیاز به آپدیت کانفیگ باشد، آپدیت شود
          if (updateConfig) this.updateConfig();

          this.loadingItem = false;
          this.$emit("change", this.items);
        });
    },
    initialColumns() {
      this.columns = [
        {
          label: "",
          key: "row",
          sortable: false,
        },
      ];
    },
    async renderFilterCache() {
      if (this.filterCatch) {
        this.loadingItem = true;
        const params = await this.getFilterCacheResource(
          () => (this.loadingItem = false)
        );
        if (params) {
          this.page = pathOr(1, ["page"], params);
          for (const key of Object.keys(params)) {
            this.paramsPage[key] = params[key];
          }
        }
      } else {
        this.page = 1;
        this.paramsPage["page"] = this.page;
      }
      this.paramsPage["per_page"] = this.viewCount;
      if (this.order_by) {
        this.paramsPage["order_by"] = this.order_by;
      }
    },
    async fillTable(updateConfig = false) {
      await this.renderFilterCache();
      await this.getItems(updateConfig);
      return true;
    },
    remove(item) {
      this.confirmRemoveItem = item;
      this.deleteModal = true;
    },
    handleAdd() {
      if (this.baseButtonAdd) {
        this.$emit("handleAdd");
      } else {
        this.addModal = true;
      }
    },
    editItem(item) {
      if (!this.editRoute) {
        this.$emit("edit-item", item);
      } else {
        if (this.openNewTab) {
          let params = {};
          params[this.primaryKey] = item[this.primaryKey];
          let routeData = this.$router.resolve({
            name: this.routeName,
            params: params,
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push("edit/" + item[this.primaryKey]);
        }
      }
    },
    changePage(page) {
      let params = {
        page,
      };
      this.paramsPage["page"] = page;
      this.page = page;
      this.getItems(true, params);
    },
    changeViewCount(value) {
      this.viewCount = value;
      this.paramsPage["per_page"] = this.viewCount;
      this.getItems();
    },
    removeModalHidden() {
      this.$emit("removeModalHidden");
    },
    rowClicked(item) {
      if (this.editByRowClick) {
        this.editItem(item);
      }
    },
    showFilterModal() {
      this.filterModal = true;
    },
    async refreshList(callback) {
      try {
        await this.fillTable();
      } catch (error) {
        this.$generateError(error);
      } finally {
        callback();
      }
    },
    getParamsPage(data) {
      this.paramsPage = data;
    },
    rowSelected(item, callback) {
      this.$emit("rowSelected", item, callback);
    },
    rowAllItems(items) {
      this.$emit("rowAllItems", items);
    },
    rowAllSelected(items) {
      this.$emit("rowAllSelected", items);
    },
    countClicked(item, countKey) {
      this.$emit("countClicked", item, countKey);
    },
  },
};
</script>
<style lang="scss">
.card {
  margin-bottom: 0;
}

.cursor-move {
  cursor: all-scroll;
}

.position-badge {
  position: absolute !important;
  right: -6px;
  top: -7px !important;
}

.dropdown-toggle {
  padding: 5px !important;
}

th:focus,
tr:focus {
  outline: 0px;
}

.fontSize-15 {
  font-size: 15px;
}
</style>
